import { get, put,Delete,post } from '../axios'

// 增值服务套餐-列表
export const packageList = params => get(`/web/service/package/list`,params);

// 增值服务套餐-新增
export const packageAdd = params => post(`/web/service/package/add`,params);

// 增值服务套餐-删除
export const packageDelete = params => Delete('/web/service/package/delete/' + params.id, '');

// 增值服务套餐-编辑
export const packageUpdate = params => put(`/web/service/package/update`,params);

